import { Input } from "antd";
import { IModelMemberInfo } from "../domain/ModelInfos/IModelInfo";

interface IProps {
    modelMember?: IModelMemberInfo;
    onChange: (changes: Partial<IModelMemberInfo>) => any;
}
export function ModelMemberNameEditor(props: IProps) {
    const { modelMember, onChange } = props;
    if (!modelMember) return <></>;
    return <Input size="small" value={modelMember.name} onChange={(e) => onChange({ name: e.target.value })} />;
}
